<template>
  <div class="section section_blue">
    <div class="max-width">
      <div class="built">
        <div class="section__head">
          <h2 class="section__title">Everything You Need for a High-Performing Store</h2>
          <div class="section__text">Every detail is purposefully built to help your store succeed.</div>
        </div>

        <div class="built__grid">
          <div class="built__card fadeIn">
            <div class="built__icon">
              <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_180_1502)">
                  <path d="M5 22V9C5 8.46957 5.21071 7.96086 5.58579 7.58579C5.96086 7.21071 6.46957 7 7 7H25C25.5304 7 26.0391 7.21071 26.4142 7.58579C26.7893 7.96086 27 8.46957 27 9V22" stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M3 22H29V24C29 24.5304 28.7893 25.0391 28.4142 25.4142C28.0391 25.7893 27.5304 26 27 26H5C4.46957 26 3.96086 25.7893 3.58579 25.4142C3.21071 25.0391 3 24.5304 3 24V22Z" stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M18 11H14" stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </g>
                <defs>
                  <clipPath id="clip0_180_1502">
                    <rect width="32" height="32" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <h3 class="built__label">User-Friendly Design</h3>
            <div class="built__desc">Clean, modern, and professional—our themes are built to help your brand shine with top-tier functionality and thoughtful design.</div>
          </div>

          <div class="built__card fadeIn">
            <div class="built__icon">
              <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16 25C16.5523 25 17 25.4477 17 26C17 26.5523 16.5523 27 16 27H11C10.4477 27 10 26.5523 10 26C10 25.4477 10.4477 25 11 25H16ZM23 5C23.7956 5 24.5585 5.3163 25.1211 5.87891C25.6837 6.44152 26 7.20435 26 8V9H28C29.6569 9 31 10.3431 31 12V24C31 25.6569 29.6569 27 28 27H22C20.3431 27 19 25.6569 19 24V23H5C4.20435 23 3.44152 22.6837 2.87891 22.1211C2.3163 21.5585 2 20.7956 2 20V8C2 7.20435 2.3163 6.44152 2.87891 5.87891C3.44152 5.3163 4.20435 5 5 5H23ZM22 11C21.4477 11 21 11.4477 21 12V24C21 24.5523 21.4477 25 22 25H28C28.5523 25 29 24.5523 29 24V12C29 11.4477 28.5523 11 28 11H22ZM5 7C4.73478 7 4.48051 7.10543 4.29297 7.29297C4.10543 7.48051 4 7.73478 4 8V20C4 20.2652 4.10543 20.5195 4.29297 20.707C4.48051 20.8946 4.73478 21 5 21H19V12C19 10.3431 20.3431 9 22 9H24V8C24 7.73478 23.8946 7.48051 23.707 7.29297C23.5195 7.10543 23.2652 7 23 7H5Z" fill="#000"/>
              </svg>
            </div>
            <h3 class="built__label">Responsive & Mobile-Optimized</h3>
            <div class="built__desc">Seamlessly adapts to every device and screen size, delivering a flawless experience on desktops, tablets, and smartphones.</div>
          </div>

          <div class="built__card fadeIn">
            <div class="built__icon">
              <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M20 11H6C5.44772 11 5 11.4477 5 12V26C5 26.5523 5.44772 27 6 27H20C20.5523 27 21 26.5523 21 26V12C21 11.4477 20.5523 11 20 11Z" stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M20 5H18" stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M25 5H26C26.2652 5 26.5196 5.10536 26.7071 5.29289C26.8946 5.48043 27 5.73478 27 6V7" stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M27 14V12" stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M25 21H26C26.2652 21 26.5196 20.8946 26.7071 20.7071C26.8946 20.5196 27 20.2652 27 20V19" stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M13 5H12C11.7348 5 11.4804 5.10536 11.2929 5.29289C11.1054 5.48043 11 5.73478 11 6V7" stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </div>
            <h3 class="built__label">Customization Options</h3>
            <div class="built__desc">Packed with intuitive controls and versatile settings, our themes make it easy to create a store that reflects your unique brand identity.</div>
          </div>

          <div class="built__card fadeIn">
            <div class="built__icon">
              <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 23.0001V20.1413C3 12.9563 8.76875 7.02508 15.9537 7.00008C17.6648 6.99399 19.3603 7.32576 20.9428 7.97634C22.5254 8.62693 23.964 9.58354 25.1761 10.7913C26.3881 11.9991 27.3498 13.4342 28.006 15.0145C28.6622 16.5947 29 18.289 29 20.0001V23.0001C29 23.2653 28.8946 23.5197 28.7071 23.7072C28.5196 23.8947 28.2652 24.0001 28 24.0001H4C3.73478 24.0001 3.48043 23.8947 3.29289 23.7072C3.10536 23.5197 3 23.2653 3 23.0001Z" stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M16 7V11" stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M13 24L21 13" stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M25 18H28.8475" stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M3.17383 18H7.00008" stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </div>
            <h3 class="built__label">Fast Loading Times</h3>
            <div class="built__desc">Optimized for speed to keep visitors engaged, lower bounce rates, and boost your SEO rankings.</div>
          </div>

          <div class="built__card fadeIn">
            <div class="built__icon">
              <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_181_1604)">
                  <path d="M23 13H29V7" stroke="#000" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M23.5501 24C21.9776 25.4838 20.0028 26.4713 17.8723 26.8391C15.7418 27.207 13.5501 26.9388 11.5712 26.0682C9.59222 25.1976 7.91369 23.7631 6.74532 21.944C5.57695 20.1249 4.97055 18.0018 5.00189 15.8401C5.03323 13.6783 5.70092 11.5737 6.92153 9.7892C8.14214 8.00472 9.86155 6.6195 11.8649 5.80662C13.8683 4.99375 16.0668 4.78926 18.1857 5.21871C20.3046 5.64815 22.25 6.6925 23.7788 8.22124L29.0001 13" stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </g>
                <defs>
                  <clipPath id="clip0_181_1604">
                    <rect width="32" height="32" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <h3 class="built__label">Regular Updates</h3>
            <div class="built__desc">Improvements and updates delivered regularly, ensuring a smooth, secure, and efficient operation of your site.</div>
          </div>

          <div class="built__card fadeIn">
            <div class="built__icon">
              <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_181_1609)">
                  <path d="M23 10H5C4.44772 10 4 10.4477 4 11V25C4 25.5523 4.44772 26 5 26H23C23.5523 26 24 25.5523 24 25V11C24 10.4477 23.5523 10 23 10Z" stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M8 10V7C8 6.73478 8.10536 6.48043 8.29289 6.29289C8.48043 6.10536 8.73478 6 9 6H27C27.2652 6 27.5196 6.10536 27.7071 6.29289C27.8946 6.48043 28 6.73478 28 7V21C28 21.2652 27.8946 21.5196 27.7071 21.7071C27.5196 21.8946 27.2652 22 27 22H24" stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M4 14H24" stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </g>
                <defs>
                  <clipPath id="clip0_181_1609">
                    <rect width="32" height="32" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <h3 class="built__label">Cross-Browser Compatibility</h3>
            <div class="built__desc">Tested across all major browsers to guarantee consistent design and performance for every visitor.</div>
          </div>

          <div class="built__card fadeIn">
            <div class="built__icon">
              <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16 21C18.7614 21 21 18.7614 21 16C21 13.2386 18.7614 11 16 11C13.2386 11 11 13.2386 11 16C11 18.7614 13.2386 21 16 21Z" stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M16.2563 25.7638C16.0888 25.7638 15.92 25.7638 15.7563 25.7638L11.75 28C10.1904 27.4754 8.74387 26.6611 7.48628 25.6L7.47128 21.1C7.38253 20.96 7.29878 20.8187 7.22128 20.6737L3.23753 18.405C2.92375 16.8179 2.92375 15.1846 3.23753 13.5975L7.21753 11.335C7.29878 11.1913 7.38253 11.0487 7.46753 10.9087L7.48753 6.40875C8.74399 5.34455 10.1902 4.52731 11.75 4L15.75 6.23625C15.9175 6.23625 16.0863 6.23625 16.25 6.23625L20.25 4C21.8096 4.52461 23.2562 5.33886 24.5138 6.4L24.5288 10.9C24.6175 11.04 24.7013 11.1813 24.7788 11.3263L28.76 13.5938C29.0738 15.1809 29.0738 16.8141 28.76 18.4013L24.78 20.6637C24.6988 20.8075 24.615 20.95 24.53 21.09L24.51 25.59C23.2544 26.6544 21.8091 27.472 20.25 28L16.2563 25.7638Z" stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </div>
            <h3 class="built__label">Easy to Set Up</h3>
            <div class="built__desc">Our theme allows you to create an professional-looking online store with no coding, making setup seamlessly simple.</div>
          </div>

          <div class="built__card fadeIn">
            <div class="built__icon">
              <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 22H3.75C3.55109 22 3.36032 21.921 3.21967 21.7803C3.07902 21.6397 3 21.4489 3 21.25V13C3 10.6131 3.94821 8.32387 5.63604 6.63604C7.32387 4.94821 9.61305 4 12 4C14.3869 4 16.6761 4.94821 18.364 6.63604C20.0518 8.32387 21 10.6131 21 13C21 15.3869 20.0518 17.6761 18.364 19.364C16.6761 21.0518 14.3869 22 12 22Z" stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M11.5125 21.9999C12.133 23.755 13.2824 25.2745 14.8025 26.349C16.3226 27.4236 18.1384 28.0004 20 27.9999H28.25C28.4489 27.9999 28.6396 27.9209 28.7803 27.7803C28.9209 27.6396 29 27.4488 29 27.2499V18.9999C28.9999 16.6983 28.118 14.4841 26.5356 12.8127C24.9533 11.1413 22.7906 10.1396 20.4925 10.0137" stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </div>
            <h3 class="built__label">Reliable Support Team</h3>
            <div class="built__desc">Receive a response within 15 minutes: any hour, every business day. Even during your trial, we're here whenever you need us. Choose the option that works best for you.</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
  .built {
    .section__head {
      margin:0 0 2.5rem;
      max-width:530px;
    }

    .section__title {
      font-size:2.5rem;

      @include xs {
        font-size:2rem;
      }
    }

    .section__text {
      max-width:480px;
    }

    &__grid {
      display:grid;
      grid-template-columns:repeat(3,1fr);
      gap:2rem;

      @include md {
        grid-template-columns:repeat(2,1fr);
      }

      @include xs {
        grid-template-columns:repeat(1,1fr);
        gap:1.25rem;
      }
    }

    &__card {
      padding:2rem;
      border-radius:12px;
      background:#fff;

      @include xs {
        padding:1.5rem;
      }
    }

    &__icon {
      margin:0 0 1rem;
    }

    &__label {
      font-size:1.125rem;
      margin:0 0 .5rem;
      font-family:var(--font-famil);
      font-weight:600;
    }

    &__desc {
      font-size:.875rem;
      color:var(--color-gray);
    }
  }
</style>
